import { Event } from '../types/event';

export type EventStatus = 'Upcoming' | 'Past' | 'Expired' | 'Cancelled';

export const getEventStatus = (event: Event): EventStatus => {
    const now = new Date();
    const start = new Date(event.start);
    const end = new Date(event.end);

    if (end <= now) {
        return 'Expired';
    }

    if (start <= now) {
        return 'Past';
    }

    return 'Upcoming';
};

/**
 * Returns true if the event has already ended (or started, when no end date exists).
 * Events with missing or unparseable dates are treated as non-expired.
 */
export const isEventExpired = (event: Event): boolean => {
    const now = new Date();

    if (event.end) {
        const end = new Date(event.end);
        if (!isNaN(end.getTime())) {
            return end < now;
        }
    }

    if (event.start) {
        const start = new Date(event.start);
        if (!isNaN(start.getTime())) {
            return start < now;
        }
    }

    // Missing or invalid dates: treat as non-expired
    return false;
};

/**
 * Returns a filtered copy of the event array with expired events removed.
 * Original array is never mutated.
 */
export const filterActiveEvents = (events: Event[]): Event[] =>
    events.filter((event) => !isEventExpired(event));
